export const Logo = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <span className="grid h-10 w-10 place-items-center rounded-xl bg-white p-1 shadow-[0_2px_14px_rgba(0,0,0,0.45)]">
      <img data-testid="teamup-logo-image" src="/images/teamup-icon.png" alt="TeamUp" className="h-full w-full object-contain" />
    </span>
    <span className="font-display text-lg font-bold tracking-tight text-white">
      Team<span className="text-brand">Up</span>
    </span>
  </span>
);
